const MENU_TYPES = [
  { id: 11, label: "ชั้นฟ้อง AMC" },
  { id: 12, label: "ชั้นศาล AMC" },
  { id: 13, label: "อื่น ๆ AMC" },
];

const IMAGE_TYPES = [
  { id: 20, label: "เอกสารฟ้องผู้จัดการมรดก AMC" },
  { id: 21, label: "เอกสารฟ้องปกติ AMC" },
  { id: 22, label: "เอกสารฟ้องบุริมสิทธิ AMC" },
  { id: 23, label: "พิพากษา AMC" },
  { id: 24, label: "เอกสารอื่น ๆ AMC" },
];

// menuType → allowed imageType ids
const MENU_IMAGE_MAP = {
  11: [20, 21, 22],
  12: [23],
  13: [24],
};

export { MENU_TYPES, IMAGE_TYPES, MENU_IMAGE_MAP };
